__turbopack_context__.v({
  "fade-in": "GradientPanel-module-scss-module__Gr_sla__fade-in",
  "gradientPanel": "GradientPanel-module-scss-module__Gr_sla__gradientPanel",
  "isActive": "GradientPanel-module-scss-module__Gr_sla__isActive",
});
